export const PAYOUT_METHOD = {
  LOCAL: 'LOCAL',
  INTERNATIONAL_SWIFT: 'INTERNATIONAL_SWIFT',
};
